import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import { history } from 'src/core/router'

export default function (nextState, replaceState, callback) {
  if (config.route.whiteList.indexOf(nextState.location.pathname) === -1 && !isMember()) { // 没有登录而且访问了受限页面
    history.push('/oauth/login/index')
  }
  callback()
}

function isMember() {
  const userInfo = localstorage.get('userToken') || ''
  if (userInfo && userInfo!='') {
    return true
  }else{
    return false
  }
}


// WEBPACK FOOTER //
// ./core/oauth.js